import Dashboard_Financeiro_NiwanBernardo from './Dashboard_Financeiro_NiwanBernardo.png';
import Dashboard_Eletronicos_NiwanBernardo from './Dashboard_Eletronicos_NiwanBernardo.png';
import Portfolio_Responsivo_NiwanBernardo from './Portfolio_Responsivo_NiwanBernardo.png';

export const projects = [
  {
    title: "Perfomance Financeira",
    description:
      "Projeto de Business Intelligence que fornece detalhes de um negócio e informações relevantes para auxiliar na tomada de decisões estratégicas.",
    image: Dashboard_Financeiro_NiwanBernardo,
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7084604567148998656/",
    subtitle: "SQL, Excel, Power BI.",
  },
  {
    title: "Perfomance Vendas de Eletrônicos",
    description:
      "Projeto de Business Intelligence que fornece detalhes de um negócio e informações relevantes para auxiliar na tomada de decisões estratégicas.",
    image: Dashboard_Eletronicos_NiwanBernardo,
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7086740929067253760/",
    subtitle: "SQL, Excel, Power BI.",
  },
  {
    title: "Landing Page Portfolio",
    description:
      "Criação de uma Landing Page simples para apresentação e portfolio.",
    image: Portfolio_Responsivo_NiwanBernardo,
    link: ".",
    subtitle: "HTML, CSS, JS, React.",
  },
];
